import { Directive, ElementRef, EventEmitter, HostListener, Input, Output } from "@angular/core";

@Directive({
    selector: '[blockButtonToSingleClick]'
})
export class BlockButtonToSingleClickDirective {
    constructor(private el: ElementRef) { }
    @Input('blockButtonTime') blockButtonTime: number = 2000;

    @HostListener('click', ['$event'])
    onClick(e) {
        this.el.nativeElement.disabled = true;
        setTimeout(() => {
            this.el.nativeElement.disabled = false;
        }, this.blockButtonTime);
    }
}